import { mmss, eventAt } from '../../engine/caseReplay';
import styles from './ReplayBar.module.css';

const KIND_COLOR = {
  scenario: '#FFB74D',
  modifier: '#B388FF',
  intervention: '#00BCD4',
  procedure: '#FF80AB',
  shock: '#FF1744',
  screen: '#66BB6A',
  media: '#4DD0E1',
  aid: '#FFF176',
  change: '#8899aa',
};

const SPEEDS = [1, 2, 4, 8];

export default function ReplayBar({ caseData, t, playing, speed, onToggle, onSeek, onSpeed, onStep, onLoadNew }) {
  const dur = caseData.durationMs || 1;
  const now = eventAt(caseData, t);

  return (
    <div className={styles.bar}>
      <div className={styles.controls}>
        <button className={styles.stepBtn} onClick={() => onStep(-1)} title="Previous event / change">⏮</button>
        <button className={styles.playBtn} onClick={onToggle} title={playing ? 'Pause' : 'Play'}>
          {playing ? '❚❚' : '►'}
        </button>
        <button className={styles.stepBtn} onClick={() => onStep(1)} title="Next event / change">⏭</button>
        <div className={styles.speeds}>
          {SPEEDS.map((s) => (
            <button key={s} className={`${styles.speed} ${speed === s ? styles.speedOn : ''}`} onClick={() => onSpeed(s)}>{s}×</button>
          ))}
        </div>
      </div>

      <div className={styles.timeline}>
        {/* Event / keyframe markers over the scrubber track */}
        <div className={styles.markers}>
          {caseData.keyframes.map((k, i) => (
            <span
              key={i}
              className={styles.marker}
              style={{ left: `${(k.t / dur) * 100}%`, background: KIND_COLOR[k.kind] || '#888' }}
              title={`${mmss(k.t)} · ${k.kind}: ${k.label}`}
              onClick={() => onSeek(k.t)}
            />
          ))}
        </div>
        <input
          type="range"
          className={styles.scrubber}
          min={0}
          max={dur}
          step={100}
          value={Math.min(t, dur)}
          onChange={(e) => onSeek(Number(e.target.value))}
          aria-label="Replay position"
        />
      </div>

      <div className={styles.right}>
        <span className={styles.time}>{mmss(t)} / {mmss(dur)}</span>
        <span className={styles.nowEvent}>
          {now ? (
            <>
              <span className={styles.nowDot} style={{ background: KIND_COLOR[now.kind] || '#888' }} />
              {now.label}
            </>
          ) : <span className={styles.dim}>—</span>}
        </span>
        <button className={styles.loadBtn} onClick={onLoadNew} title="Load a different case">⤒</button>
      </div>
    </div>
  );
}
